import React, { useState } from "react";

import { useStaticQuery, graphql, Link } from "gatsby";

import { Dialog } from "@headlessui/react";

import Cross from "images/svg/cross.svg";
import MessageLeft from "images/svg/message-left.svg";
import MessageRight from "images/svg/message-right.svg";

const DownloadPopupModal = ({
  downloadURL,
  sendTrackerEvent,
  showDownloadPopupModal,
  setShowDownloadPopupModal,
}: {
  downloadURL: string;
  sendTrackerEvent: any;
  showDownloadPopupModal: boolean;
  setShowDownloadPopupModal: any;
}) => {
  // eslint-disable-next-line no-undef
  const metadata = useStaticQuery<Queries.FetchMetadataExitModalQuery>(
    graphql`
      query FetchMetadataExitModal {
        site {
          siteMetadata {
            title
          }
        }
      }
    `
  );

  const [subscriberEmail, setSubscriberEmail] = useState("");
  const title = metadata?.site?.siteMetadata?.title;

  function handleCloseModal() {
    setShowDownloadPopupModal(false);
  }

  function openDownloadLink() {
    window.open(downloadURL, "_blank");
  }

  function saveDownloadModalData() {
    window.localStorage.setItem("downloadModalShown", "true");
    window.localStorage.setItem("downloadModalEmail", subscriberEmail);
  }

  function handleFormSubmit() {
    saveDownloadModalData();
    openDownloadLink();
    sendTrackerEvent();
  }

  return (
    <>
      <div
        className={`fixed inset-0 z-50 ${
          showDownloadPopupModal ? "bg-slate-500 bg-opacity-50" : ""
        }`}
      ></div>

      <Dialog
        className="fixed left-1/2 top-1/2 z-50 w-[90%] -translate-x-1/2 -translate-y-1/2 transform overflow-clip rounded-[1.875rem] bg-primary-500 px-5 py-10 text-center text-white shadow-lg sm:w-2/4 sm:px-10 lg:px-20"
        open={showDownloadPopupModal}
        onClose={() => setShowDownloadPopupModal(false)}
      >
        <Dialog.Panel className="flex flex-col gap-[1.875rem]">
          <Dialog.Title className="md:text-4=3xl text-2xl font-semibold xl:text-4xl">
            Get Notified of New Themes from {title}!
          </Dialog.Title>
          <p className="mb-8 md:text-xl">
            Want to be the first to know when we release new themes? We`ll only
            send you updates when we release new themes or have important
            updates to share.
          </p>
          <form
            onSubmit={handleFormSubmit}
            className="flex justify-center"
            action="https://app.gumroad.com/follow_from_embed_form"
            method="post"
            id="gumroad-follow-form-embed"
          >
            <div className="relative w-3/4 text-black">
              <input
                type="hidden"
                className="hidden"
                name="seller_id"
                value={`${process.env.GATSBY_GUMROAD_SELLER_ID}`}
              />
              <input
                id="gumroad-follow-form-embed-input"
                className="mb-4 block w-full rounded-lg border p-4"
                placeholder="Enter your email "
                type="email"
                name="email"
                value={subscriberEmail}
                onChange={(e) => setSubscriberEmail(e.target.value)}
              />
              <button
                id="gumroad-follow-form-embed-button"
                type="submit"
                className="btn-primary absolute right-2 top-2 block cursor-pointer"
              >
                Download Now
              </button>
            </div>
          </form>
          <div className="flex flex-col gap-2.5">
            <p className="text-xl"> Thanks for choosing {title}</p>
            <p className="text-xs">
              <Link
                to="/"
                onClick={saveDownloadModalData}
                className="underline underline-offset-auto"
              >
                Privacy Policy
              </Link>{" "}
              and{" "}
              <Link
                to="/"
                onClick={saveDownloadModalData}
                className="underline underline-offset-auto"
              >
                Terms of service
              </Link>{" "}
              apply
            </p>
          </div>
          <div className="absolute -bottom-[3.8rem] -left-7 -z-10 h-40 w-40 rounded-full bg-primary-400"></div>
          <img
            src={MessageLeft}
            alt="message left"
            className="absolute top-1/2 -z-10 hidden sm:block"
          />
          <img
            src={MessageRight}
            alt="message right"
            className="absolute right-[30px] top-3/4 -z-10 hidden sm:block"
          />
          <button
            className="absolute right-4 top-4 cursor-pointer border-none bg-transparent"
            onClick={handleCloseModal}
          >
            <img src={Cross} alt="cross" />
          </button>
        </Dialog.Panel>
      </Dialog>
    </>
  );
};

export default DownloadPopupModal;
